import Badge from '@repo/ui/badge'
import { DisplayImage } from '@repo/ui/file-input'
import InnerBox from '@repo/ui/inner-box'
import Modal from '@repo/ui/modal'

import { useModalManager } from '../../lib/hooks/use-modal-manager'
import { FileType } from '../../lib/types/models/file/file'

type Props = {
  picture: FileType
}

const ImageViewCard = ({ picture }: Props) => {
  const { modalState, selectedData, toggleModal, closeModel } = useModalManager<
    'image-preview',
    FileType
  >(['image-preview'])

  return (
    <InnerBox className="rounded-lg bg-white-hover p-4 flex flex-col gap-3">
      <Badge variant="primary" size="small" text={picture.caption} />
      <img
        src={picture.path}
        alt="Photo de la famille"
        className="w-full h-48 object-cover rounded-lg cursor-pointer"
        onClick={() => {
          toggleModal('image-preview', picture)
        }}
      />
      {selectedData && (
        <Modal
          hideHeader
          hideActions
          size={'small'}
          isOpen={modalState['image-preview']}
          onCancel={() => closeModel('image-preview')}
        >
          <DisplayImage
            type={selectedData.type}
            src={selectedData.path}
            className="w-full h-fit object-contain  "
          />
        </Modal>
      )}
    </InnerBox>
  )
}

export default ImageViewCard
